import { jsonrepair } from 'jsonrepair';

export function parseVariations(text, { partial = false, isRenderable = () => true } = {}) {
  const json = partial ? jsonrepair(text.trim().replace(/[<>/,:=\\]*$/, '')) : text;
  const { variations } = JSON.parse(json);
  if (!Array.isArray(variations)) throw new Error('Invalid variations response.');

  return [
    ...new Set(
      variations.filter((variation) => typeof variation === 'string' && variation.trim() && isRenderable(variation)),
    ),
  ];
}
